import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7be5b207"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-m" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "section-title" }, " Характеристики и статы солдат Enlisted по классам ", -1))
const _hoisted_3 = { for: "searchInput" }
const _hoisted_4 = { class: "table__search-icon tooltip-anchor" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "hotkey" }, "Esc"),
  /*#__PURE__*/_createTextVNode(" - сбросить ввод")
], -1))
const _hoisted_6 = ["placeholder", "disabled"]
const _hoisted_7 = { class: "table__wrapper mt-s" }
const _hoisted_8 = { class: "table__header table__row" }
const _hoisted_9 = { class: "table__header--col table__col table__col--first" }
const _hoisted_10 = { class: "table__header-question-icon tooltip-anchor" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Нажми по строчке чтобы включить/выключить фильтрацию.", -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"table__header--col table__col table__col--star\" data-v-7be5b207>★</div><div class=\"table__header--col table__col table__col--star\" data-v-7be5b207>★★</div><div class=\"table__header--col table__col table__col--star\" data-v-7be5b207>★★★</div><div class=\"table__header--col table__col table__col--star\" data-v-7be5b207>★★★★</div><div class=\"table__header--col table__col table__col--star\" data-v-7be5b207>★★★★★</div><div class=\"table__header--col table__col table__col--perk\" data-v-7be5b207> Начальный перк </div>", 6)
const _hoisted_18 = { class: "table__wrapper--body" }
const _hoisted_19 = {
  key: 0,
  class: "table__calculator"
}
const _hoisted_20 = {
  class: "table__promo-buttons",
  style: {"margin-top":"1.2rem"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table__promo-or" }, "ИЛИ", -1))
const _hoisted_22 = {
  key: 1,
  class: "table__promo-block"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "table__promo-title" }, "Популярные сборки от сообщества", -1))
const _hoisted_24 = { class: "table__promo-builds" }
const _hoisted_25 = { class: "table__promo-buttons" }
const _hoisted_26 = { class: "btn btn-m btn-secondary" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table__promo-or" }, "ИЛИ", -1))
const _hoisted_28 = { class: "container-sm" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "faq__section-title-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "faq__section-title" }, "Часто задаваемые вопросы")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Прокачка солдат в Enlisted зависит от класса и стиля игры. Общих правил нет, но есть топовые мета-сборки. ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Актуальные сборки можно глянуть на странице "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/skill-builds",
    class: "link"
  }, "Сборки"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Лучшие перки для солдат в Enlisted зависят от класса: пехоте - \"Живучесть\", танкистам - перк на смену снаряда. ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Пехота: \"Живучесть\" (красная ветка) + скорость бега (зелёная) + быстрая аптечка. Жёлтая ветка: уменьшение разброса, отдача (в 95% случаев вертикальная), перезарядка. ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Танкисты: перк на смену снаряда + улучшенное наведение. Водителя собирать отдельно. ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Мета-сборки можно глянуть на странице "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/skill-builds",
    class: "link"
  }, "Сборки"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Лучшие отряды для прокачки - это инженеры и штурмовики. Они наиболее эффективны в бою. ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Штурмовики - основной боевой отряд для игры, туда можно ставить специалистов. ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Инженеры - для повышения их максимального уровня. Их нужно ставить в каждый отряд. ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Оптимальная прокачка отряда - через опыт, слот инженера и численность отряда. ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Сначала открой увеличение опыта → как только сможешь - инженера → добавляй специалистов и увеличивай численность → прокачай ветку уровня специалистов отряда. ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Самый быстрый способ качаться в Enlisted - строить точки респауна инженером. ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Они дают пассивный опыт в течение всего боя, особенно если они поставлены эффективно. Поэтому в любой отряд нужно ставить инженера. ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Перк снижает разброс пуль при движении влево и вправо (стрейфы A/D). ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Полезен для штурмовиков и агрессивных игроков, особенно с автоматикой. ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Этапы событий в Enlisted обычно длятся по 2 суток.", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Точное расписание смотри на странице "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/events",
    class: "link"
  }, "События"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Награды за этапы можно посмотреть на карточках дат на странице "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/events",
    class: "link"
  }, "События"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Разработчики периодически добавляют Ящики за серебро с небольшим шансом на старые награды. ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Следи за новостями и акциями, старые скины и оружие иногда возвращают в игру. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!
  const _component_IconSearch = _resolveComponent("IconSearch")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_search = _resolveComponent("search")!
  const _component_IconQuestionCircle = _resolveComponent("IconQuestionCircle")!
  const _component_item_row = _resolveComponent("item-row")!
  const _component_calculator_block = _resolveComponent("calculator-block")!
  const _component_build_card = _resolveComponent("build-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FaqItem = _resolveComponent("FaqItem")!
  const _component_FaqGroup = _resolveComponent("FaqGroup")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", _hoisted_3, [
      _createVNode(_component_search, {
        class: "table__search",
        role: "search"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TooltipComponent, { direction: 'bottom' }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_IconBase, null, {
              default: _withCtx(() => [
                _createVNode(_component_IconSearch)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "table__input",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchValue($event.target.value))),
            id: "searchInput",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => {
						_ctx.clearSearchValue();
						$event.target.value = '';
					}, ["esc"])),
            placeholder: 
						!_ctx.isFilteredToClass ? 'Начни вводить название класса' : ''
					,
            disabled: _ctx.isFilteredToClass
          }, null, 40, _hoisted_6), [
            [_directive_focus, { onMount: true, onUpdate: true }]
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_TooltipComponent, {
              direction: 'right',
              width: 25
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_IconBase, null, {
              default: _withCtx(() => [
                _createVNode(_component_IconQuestionCircle)
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_12
      ]),
      (!_ctx.isFilteredToClass)
        ? (_openBlock(), _createBlock(_TransitionGroup, {
            key: 0,
            name: "fade",
            tag: "div",
            class: "table__wrapper--body"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item, idx) => {
                return (_openBlock(), _createBlock(_component_item_row, {
                  key: item.id,
                  item: item,
                  onClick: ($event: any) => (_ctx.handleClick(idx))
                }, null, 8, ["item", "onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isFilteredToClass)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_item_row, {
                item: _ctx.filteredItems[_ctx.activeIdx],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeFilter()))
              }, null, 8, ["item"])
            ]),
            (_ctx.isFilteredToClass && _ctx.isCalculatorSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_calculator_block, {
                    stats: _ctx.calculateStatsByLvl(_ctx.filteredItems[_ctx.activeIdx].statsMod, 5),
                    tags: _ctx.filteredItems[_ctx.activeIdx].tags,
                    soldierClass: _ctx.filteredItems[_ctx.activeIdx].id
                  }, null, 8, ["stats", "tags", "soldierClass"]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      class: "btn btn-m btn-secondary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filteredSoldierButtonHandler('presets')))
                    }, [
                      _createTextVNode(" Назад ")
                    ])), [
                      [_directive_ripple]
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadedData, (item) => {
                      return (_openBlock(), _createBlock(_component_build_card, {
                        class: "table__build",
                        key: item,
                        item: item,
                        loadedUserData: 
								_ctx.loadedUserData && _ctx.loadedUserData[item.data.author]
									? _ctx.loadedUserData[item.data.author]
									: {
											displayName: 'Пользователь не найден',
											photoURL: 'https://place-hold.it/80x80/8c8f94/8c8f94.jpg',
											emailHash: null,
											avatarProvider: null,
									  }
							,
                        isFinishedLoading: _ctx.isFinishedLoading
                      }, null, 8, ["item", "loadedUserData", "isFinishedLoading"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_router_link, { to: _ctx.link }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_26, [
                          _createTextVNode(" Посмотреть еще ")
                        ])), [
                          [_directive_ripple]
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _hoisted_27,
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      class: "btn btn-m btn-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filteredSoldierButtonHandler('calculator')))
                    }, [
                      _createTextVNode(" Создать свою сборку ")
                    ])), [
                      [_directive_ripple]
                    ])
                  ])
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createVNode(_component_FaqGroup, { title: 'Вопросы по прокачке' }, {
        default: _withCtx(() => [
          _createVNode(_component_FaqItem, { title: 'Как правильно прокачивать солдат в Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_30,
              _hoisted_31
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Какие скиллы качать бойцам в Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Какие отряды лучше прокачивать в Enlisted в первую очередь?' }, {
            default: _withCtx(() => [
              _hoisted_36,
              _hoisted_37,
              _hoisted_38
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Как правильно прокачивать отряд в Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_39,
              _hoisted_40
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Как быстро прокачаться в Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_41,
              _hoisted_42
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Что делает перк на разброс пуль после резкого разворота в Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_43,
              _hoisted_44
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FaqGroup, { title: 'Вопросы по событиям' }, {
        default: _withCtx(() => [
          _createVNode(_component_FaqItem, { title: 'Когда начинается следующий этап события в Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_45,
              _hoisted_46
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Какая награда за следующий этап события Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          }),
          _createVNode(_component_FaqItem, { title: 'Как получить награды из прошлых ивентов Enlisted?' }, {
            default: _withCtx(() => [
              _hoisted_48,
              _hoisted_49
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !_ctx.isFilteredToClass]
    ])
  ]))
}